import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconMapMarkerAltSvg } from "./IconMapMarkerAltSvg.mjs";
const IconMapMarkerAlt = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconMapMarkerAltSvg, ...iconProps });
};
export {
  IconMapMarkerAlt
};
